<template>
  <BaseModal
    v-model="isVisible"
    :title="title"
    :size="size"
    :closable="closable"
    :close-on-backdrop="closeOnBackdrop"
    @close="handleCancel"
  >
    <div class="flex items-start gap-4">
      <!-- Icon -->
      <div v-if="showIcon" :class="iconWrapperClasses">
        <slot name="icon">
          <i v-if="variant === 'danger'" class="fas fa-exclamation-triangle" style="font-size: 1.5rem;"></i>
          <i v-else-if="variant === 'warning'" class="fas fa-exclamation-circle" style="font-size: 1.5rem;"></i>
          <i v-else-if="variant === 'success'" class="fas fa-check-circle" style="font-size: 1.5rem;"></i>
          <i v-else class="fas fa-info-circle" style="font-size: 1.5rem;"></i>
        </slot>
      </div>

      <!-- Content -->
      <div class="flex-1">
        <p class="text-gray-600">
          <slot>{{ message }}</slot>
        </p>
      </div>
    </div>

    <template #footer>
      <div class="flex items-center justify-end gap-3 w-full">
        <BaseButton
          variant="ghost"
          :disabled="loading"
          @click="handleCancel"
        >
          {{ cancelText }}
        </BaseButton>
        <BaseButton
          :variant="confirmButtonVariant"
          :loading="loading"
          @click="handleConfirm"
        >
          {{ confirmText }}
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'
import BaseButton from './BaseButton.vue'

export default {
  name: 'BaseConfirmDialog',
  components: {
    BaseModal,
    BaseButton
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirmation'
    },
    message: {
      type: String,
      default: 'Êtes-vous sûr de vouloir continuer ?'
    },
    variant: {
      type: String,
      default: 'warning',
      validator: (value) => ['info', 'success', 'warning', 'danger'].includes(value)
    },
    size: {
      type: String,
      default: 'sm'
    },
    confirmText: {
      type: String,
      default: 'Confirmer'
    },
    cancelText: {
      type: String,
      default: 'Annuler'
    },
    loading: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    closeOnBackdrop: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  computed: {
    isVisible: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    iconWrapperClasses() {
      const variants = {
        info: 'flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-blue-600',
        success: 'flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-green-100 text-green-600',
        warning: 'flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-yellow-100 text-yellow-600',
        danger: 'flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-red-100 text-red-600'
      }
      return variants[this.variant]
    },
    confirmButtonVariant() {
      const variants = {
        info: 'primary',
        success: 'success',
        warning: 'warning',
        danger: 'danger'
      }
      return variants[this.variant]
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
    handleCancel() {
      this.$emit('cancel')
      this.isVisible = false
    }
  }
}
</script>
